import CodigoSiproquimModel from "@/models/codigoSiproquimModel";

import { iServiceCached } from "./base/iServiceCached";

class CodigoSiproquimService extends iServiceCached<CodigoSiproquimModel> {
    constructor() {
        super("CodigoSiproquim");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: `${p.codigo} - ${p.nomeProduto} ((NCM: ${p.ncm}))`,
        }));
    }
}

export default new CodigoSiproquimService();
